import { Injectable } from '@angular/core';
import { TokenDto } from '../../models/franchise/franchise.model';
import * as tokenUtils from './token.utils';

/**
 * Thin injectable wrapper over `token.utils`. The logic lives there as pure functions so
 * that NgRx selectors can call it without an injector (AB#92977); this class stays so the
 * existing injecting call sites are unaffected.
 */
@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  getExpirationDuration(tokenDto: TokenDto): number {
    return tokenUtils.getExpirationDuration(tokenDto);
  }

  userIsAuthenticated(tokenDto: TokenDto): boolean {
    return tokenUtils.userIsAuthenticated(tokenDto);
  }
}
